module.exports = __webpack_public_path__ + "static/media/communities-wizard-final-page.9667dea3.png";